export const WHATSAPP_STEPS = [
  // Section 1: You
  "chooseGoal",
  "mainGoal",
  "goalReason",

  // Section 2: Tracking Experience
  "calorieCountingExperience",
  "trackingChallenges",
  "idealTracking",

  // Section 3: WhatsApp
  "whatsAppUsage",
  "messagingStyle",
  "whatsAppDemo",
  "reminderPreference",
  "coachingFeatures",
  "whatsAppCoachingDemo",

  // Section 4: Your Body
  "height",
  "weight",
  "goalWeight",
  "age",
  "activityLevel",

  // Section 5: Your Plan
  "wellnessSnapshot",
  "progressPlan",

  // Section 6: Account Creation
  "password",
  "email",
] as const

export const WHATSAPP_SECTIONS = [
  {
    name: "You",
    steps: ["chooseGoal", "mainGoal", "goalReason"],
  },
  {
    name: "Tracking",
    steps: ["calorieCountingExperience", "trackingChallenges", "idealTracking"],
  },
  {
    name: "WhatsApp",
    steps: [
      "whatsAppUsage",
      "messagingStyle",
      "whatsAppDemo",
      "reminderPreference",
      "coachingFeatures",
      "whatsAppCoachingDemo",
    ],
  },
  {
    name: "Your Body",
    steps: ["height", "weight", "goalWeight", "age", "activityLevel"],
  },
  {
    name: "Your Plan",
    steps: ["wellnessSnapshot", "progressPlan"],
  },
  {
    name: "Create Account",
    steps: ["password", "email"],
  },
] as const
